import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import { message } from "antd";
import LoadingOverlay from "react-loading-overlay";
import axios from "../../axios/axios";
import moment from "moment";
import { Button, Form } from "react-bootstrap";
import { CSVLink } from "react-csv";
import { DATE_FORMAT } from "../../constants/constants";
import { adminConfig } from "../../utils/adminConfig";

export default function AnniversaryReports() {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [loading, setLoading] = useState(false);
  const [members, setMembers] = useState([]);
  const [pagination, setPagination] = useState({
    limit: 10,
    page: 1,
    totalPage: 0,
    totalRows: 0,
  });
  const [search, setSearch] = useState("");
  const [query, setQuery] = useState("");
  const [source, setSource] = useState("tvi");
  const [csvData, setCsvData] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [selectedStartDate, setSelectedStartDate] = useState("");
  const [selectedEndDate, setSelectedEndDate] = useState("");

  const columns = [
    {
      name: "Name",
      selector: ({ name }) => name,
      width: "300px",
    },
    {
      name: "Email",
      selector: ({ email }) => email,
      width: "350px",
    },
    {
      name: "UserName",
      selector: ({ userName }) => userName,
      width: "350px",
    },
    {
      name: "Phone",
      selector: ({ phone }) => phone,
      width: "150px",
    },
    {
      name: "Address",
      selector: ({ address }) => address,
      width: "350px",
    },
    {
      name: "Country",
      selector: ({ country }) => country,
      width: "100px",
    },
    {
      name: "Status",
      selector: ({ status }) => (status ? "Active" : "Inactive"),
      width: "100px",
    },
    {
      name: "Created At",
      selector: ({ createdAt }) => moment(createdAt).format(DATE_FORMAT),
      sortable: true,
      width: "200px",
    },
  ];

  const customStyles = {
    header: {
      style: {
        minHeight: "56px",
      },
    },
    headRow: {
      style: {
        borderTopStyle: "solid",
        borderTopWidth: "1px",
      },
    },
    headCells: {
      style: {
        "&:not(:last-of-type)": {
          borderRightStyle: "solid",
          borderRightWidth: "1px",
        },
        fontSize: "17px",
        color: "#004aad",
      },
    },
    cells: {
      style: {
        "&:not(:last-of-type)": {
          borderRightStyle: "solid",
          borderRightWidth: "1px",
        },
        fontSize: "16px",
      },
    },
  };

  useEffect(() => {
    getAllAnniversaryMembers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, limit, search, source, startDate, endDate]);

  const getAllAnniversaryMembers = () => {
    setLoading(true);
    axios
      .get(
        `/reports/anniversary-members?source=${source}&page=${page}&limit=${limit}&search=${search}&startDate=${startDate}&endDate=${endDate}`,
        adminConfig()
      )
      .then((res) => {
        setLoading(false);
        if (res.data.status) {
          setMembers(res.data.data);
          setPagination(res.data.pagination);
        } else {
          message.error(res.data.message);
        }
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  const handlePerRowsChange = (newPerPage) => {
    setLimit(newPerPage);
    setPage(1);
  };

  const changePage = (newPage) => {
    setPage(newPage);
  };

  const exportCSV = () => {
    setLoading(true);
    axios
      .get(
        `/reports/csv-anniversary-members?source=${source}&search=${search}&startDate=${startDate}&endDate=${endDate}`,
        adminConfig()
      )
      .then((res) => {
        setLoading(false);
        if (res.data.status) {
          const csvData = res.data.data.map((member) => ({
            Name: member.name,
            Email: member.email,
            UserName: member.userName,
            Phone: member.phone,
            Address: member.address,
            Country: member.country,
            Status: member.status ? "Active" : "Inactive",
            CreatedAt: moment(member.createdAt).format("MM-DD-YYYY"),
          }));
          setCsvData(csvData);
          setTimeout(() => {
            document.getElementById("csv-download-link").click();

            setLoading(false);
          }, 2000);
        } else {
          message.error(res.data.message);
        }
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  const csvHeaders = [
    { label: "Name", key: "Name" },
    { label: "Email", key: "Email" },
    { label: "UserName", key: "UserName" },
    { label: "Phone", key: "Phone" },
    { label: "Address", key: "Address" },
    { label: "Country", key: "Country" },
    { label: "Status", key: "Status" },
    { label: "CreatedAt", key: "CreatedAt" },
  ];

  return (
    <LoadingOverlay active={loading} spinner text="Loading ...">
      <div className="right_cont">
        <div className="right_banner_banner_cnt">
          <div className="travel_deals_admin">
            <h2>Hello, Admin!</h2>
            <div className="text_field_partts">
              <div className="user_added">
                <div className="ar_count_card d-flex">
                  <h3>Anniversary Reports {source.toUpperCase()}</h3>
                  <div className="ar_count">{pagination.totalRows}</div>
                </div>
                <div className="filter_section">
                  <div className="input-group filter_fields">
                    <div className="search_field">
                      <input
                        placeholder="Type name or email or phone or username"
                        type="text"
                        id="form1"
                        className="form-control"
                        onChange={(e) => {
                          setQuery(e.target.value);
                        }}
                        value={query}
                      />
                    </div>
                    <Form.Group controlId="formBasicEmail" className="dt_range">
                      <Form.Label>Start Date</Form.Label>
                      <Form.Control
                        type="date"
                        value={selectedStartDate}
                        max={selectedEndDate || moment().format("YYYY-MM-DD")}
                        onChange={(e) => setSelectedStartDate(e.target.value)}
                      />
                    </Form.Group>

                    <Form.Group controlId="formBasicEmail" className="dt_range">
                      <Form.Label>End Date</Form.Label>
                      <Form.Control
                        type="date"
                        value={selectedEndDate}
                        min={selectedStartDate}
                        max={moment().format("YYYY-MM-DD")}
                        onChange={(e) => setSelectedEndDate(e.target.value)}
                      />
                    </Form.Group>

                    <Button
                      className="search_button"
                      variant="primary"
                      onClick={() => {
                        setSearch(query);
                        setStartDate(selectedStartDate);
                        setEndDate(selectedEndDate);
                        setPage(1);
                      }}
                    >
                      Search
                    </Button>

                    <Button
                      className="search_button"
                      variant="secondary"
                      onClick={() => {
                        setSelectedStartDate("");
                        setSelectedEndDate("");
                        setStartDate("");
                        setEndDate("");
                        setSearch("");
                        setQuery("");
                        setPage(1);
                      }}
                    >
                      Clear Filter
                    </Button>
                  </div>
                  <div className="filter_btns">
                    <Button
                      className="btn btn-primary search_button"
                      onClick={exportCSV}
                    >
                      Export CSV
                    </Button>
                    <CSVLink
                      data={csvData}
                      headers={csvHeaders}
                      filename={`${source}_anniversary_members.csv`}
                      className="hidden"
                      id="csv-download-link"
                      target="_blank"
                    />
                    <select
                      className="form-control"
                      onChange={(e) => {
                        setSource(e.target.value);
                      }}
                      value={source}
                    >
                      <option value=""> Select Members</option>
                      <option value="tvi">TVI</option>
                      <option value="tv">TV</option>
                    </select>
                  </div>
                </div>

                <DataTable
                  columns={columns}
                  data={members}
                  pagination
                  striped
                  responsive
                  customStyles={customStyles}
                  subHeaderAlign="right"
                  subHeaderWrap
                  paginationDefaultPage={page}
                  paginationServer
                  paginationTotalRows={pagination.totalRows}
                  paginationPerPage={limit}
                  paginationRowsPerPageOptions={[10, 15, 20, 40]}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={changePage}
                  className={members.length === 1 ? "search_state" : ""}
                  progressComponent={<CustomLoader />}
                  noDataComponent={<EmptyDataLoader />}
                  fixedHeaderScrollHeight="500px"
                  fixedHeader
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </LoadingOverlay>
  );
}

const CustomLoader = () => (
  <div
    style={{
      padding: "15px",
      background: "#495A71",
      color: "#fff",
      width: "100%",
      fontSize: "40px",
      textAlign: "center",
      minHeight: "350px",
      lineHeight: "400px",
    }}
  >
    <div>Loading...</div>
  </div>
);
const EmptyDataLoader = () => (
  <div
    style={{
      padding: "15px",
      background: "#495A71",
      color: "#fff",
      width: "100%",
      fontSize: "40px",
      textAlign: "center",
      minHeight: "350px",
      lineHeight: "400px",
    }}
  >
    <div>No data found...</div>
  </div>
);
